<template>
    <div :class="inputClass">
        <div class="form-input-toggle__option">
            <input
                :id="_uid"
                :checked="value"
                :data-checked="value"
                :autofocus="hasAutofocus"
                :required="isRequired"
                :disabled="isDisabled"
                type="checkbox"
                @change="change(!value)"
            />

            <label :for="_uid">
                <common-icon :name="checkboxIcon" size="medium"></common-icon>

                <span>
                    <slot name="label">
                        {{ label }}
                    </slot>
                </span>
            </label>
        </div>
    </div>
</template>

<script>
    import FormInputMixin from 'mixins/FormInputMixin'

    export default {
        mixins: [FormInputMixin],

        props: {
            label: { type: String, default: undefined },
            value: { type: Boolean, default: false },
            hasBigTapArea: { type: Boolean, default: false },
            direction: { type: String, default: 'row' },
            checkedIcon: { type: String, default: null },
            color: { type: String, default: 'primary' },
        },

        computed: {
            checkboxIcon() {
                return this.value ? this.checkedIcon || 'checkbox-on' : 'checkbox-off'
            },

            inputClass() {
                return {
                    'form-input-toggle': true,
                    'form-input-toggle--has-big-tap-area': this.hasBigTapArea,
                    'form-input-toggle--is-disabled': this.isDisabled,
                    [`form-input-toggle__option--${this.color}`]: true,
                }
            },
        },
    }
</script>
